import {
  AudioLine,
  CalendarLine,
  ConversationLine,
  EmailLine,
  FolderLine,
  ImageLine,
  PaperDocLine,
  PdfLine,
  SlidesLine,
  TableLine,
  VideoLine,
} from "@dropbox/dig-icons/assets";
import type { FilterableContentTypeKeys } from "@mirage/shared/content-type/content-types";
import type { I18nKey } from "@mirage/translations";
import type React from "react";

export const filterableContentTypeIcons: Record<
  FilterableContentTypeKeys,
  (props: React.SVGProps<SVGSVGElement>) => React.ReactElement
> = {
  folder: FolderLine,
  document: PaperDocLine,
  presentation: SlidesLine,
  spreadsheet: TableLine,
  pdf: PdfLine,
  video: VideoLine,
  image: ImageLine,
  audio: AudioLine,
  email: EmailLine,
  event: CalendarLine,
  messages: ConversationLine,
};

export const filterableContentTypeLabels: Record<
  FilterableContentTypeKeys,
  I18nKey
> = {
  folder: "folders_category",
  document: "documents_category",
  presentation: "presentation_category",
  spreadsheet: "spreadsheet_category",
  pdf: "pdf_category",
  video: "videos",
  image: "images",
  audio: "audio_content_type",
  email: "email_category",
  event: "events_category",
  messages: "messages_category",
};
